import {Services} from "@ca.vmedia.tv/services";

export const useResources = (resourceCode: string): Promise<string> => {
    return Services.Instance.domains.resourcesRepository.getResources(resourceCode);
};